import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/ProgramsAssignment';

const ProgramsAssignment = () => {
    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default ProgramsAssignment;
